import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AlertMessage from "../include/AlertMessage";
import { storage, ID, Permission, Role } from "../../appwrite/config";
var _ = require('lodash');

function AddCoupon() {
    const { role, user } = useAuth();
    const [alert, setAlert] = useState({ type: "", message: "" });
    const [formData, setFormData] = useState({ shopid: '', code: '', description: '', expiryDate: '', isActive: false });
    const [errors, setErrors] = useState({});
    const [allShops, setShops] = useState([]);
    const [loading, setLoading] = useState(true);
    const [image, setImage] = useState(null);
    const redirectHistory = useNavigate();

    const token = sessionStorage.getItem('JWT_TOKEN');

    const fetchAllShops = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/shops/dropdown`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                }
            );

            const shopsdata = await response.data;
            if (Array.isArray(shopsdata.data) && shopsdata.data.length > 0) {
                setShops(shopsdata.data);
            } else {
                setShops([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.documentElement.className = "";

        fetchAllShops();
    }, []);


    const validate = () => {
        const newErrors = {};
        if (!formData.shopid) newErrors.shopid = "Shop is required.";
        // if (!formData.code) newErrors.code = "Code is required.";
        if (!formData.code) {
            newErrors.code = "Code is required.";
        } else if (formData.code.length > 10) {
            newErrors.code = "Code must not exceed 10 characters.";
        }

        if (!formData.description) newErrors.description = "Description is required.";
        if (!formData.expiryDate) newErrors.expiryDate = "Expiry Date is required.";
        //if (!image) newErrors.image = "Image is required.";
        return newErrors;
    };

    // ✅ SINGLE FILE HANDLER
    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
        const maxSize = 5 * 1024 * 1024; // 5MB

        // ❌ TYPE CHECK
        if (!allowedTypes.includes(file.type)) {
            setAlert({
                type: "error",
                message: "Only JPG, PNG, WEBP images are allowed."
            });
            return;
        }

        // ❌ SIZE CHECK
        if (file.size > maxSize) {
            setAlert({
                type: "error",
                message: "Image size must be less than 5MB."
            });
            return;
        }

        // ✅ VALID FILE
        setImage({
            file: file,
            preview: URL.createObjectURL(file)
        });
    };

    const handleRemoveImage = () => {
        const confirmDelete = window.confirm("Are you sure you want to delete this image?");
        if (!confirmDelete) return;

        setImage(null);
    };


    const handleAdd = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            try {
                let fileId = "";

                // =========================
                // UPLOAD IMAGE TO APPWRITE
                // =========================
                if (image?.file) {

                    const uploadedFile = await storage.createFile(
                        process.env.REACT_APP_BUCKET_ID,
                        ID.unique(),
                        image.file,
                        [
                            Permission.read(Role.any()),
                            Permission.write(Role.any())
                        ]
                    );

                    fileId = uploadedFile.$id;
                }


                //API URL
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/addcoupon`,
                    {
                        shopID: formData.shopid,
                        code: formData.code,
                        description: formData.description,
                        expiryDate: formData.expiryDate,
                        isActive: formData.isActive,
                        image: fileId
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    setAlert({ type: "success", message: "Coupon added successfully!" });
                    setTimeout(() => redirectHistory('/coupons'), 2500); // thoda delay deke redirect                    
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to add coupon. Please try again");
                setAlert({ type: "error", message: apierror });
            }

        }
    }


    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/coupons" className='btn btn-primary'>Coupons</Link></li>
                        <li>Add</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Add Coupon
                            </p>
                        </header>
                        <div className="card-content">
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (

                                <form onSubmit={handleAdd}>
                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() => setAlert({ type: "", message: "" })}
                                        />
                                    )}

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">Select Businesses <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <div className="select">
                                                    <select id="shopid" value={formData.shopid} onChange={e => setFormData({ ...formData, shopid: e.target.value })}>
                                                        <option value={''}>---Select---</option>
                                                        {allShops.map((shop, index) => (
                                                            <option key={shop.$id} value={shop.$id}>{shop.name}</option>
                                                        ))}
                                                    </select>
                                                    {errors.shopid && <p className="help" style={{ color: 'red' }}>{errors.shopid}</p>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="field">
                                            <label className="label">Code <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="code" type="text" placeholder="Code" value={formData.code} onChange={e => setFormData({ ...formData, code: e.target.value })} />
                                            </div>
                                            {errors.code && <p className="help" style={{ color: 'red' }}>{errors.code}</p>}
                                        </div>

                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">Expiry Date <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="expiryDate" type="date" placeholder="Expiry Date" value={formData.expiryDate} onChange={e => setFormData({ ...formData, expiryDate: e.target.value })} />
                                            </div>
                                            {errors.expiryDate && <p className="help" style={{ color: 'red' }}>{errors.expiryDate}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label">Image</label>
                                            <div className="control">
                                                <input className="input" id="simage" accept="image/*" type="file" onChange={handleFileChange} />
                                            </div>
                                            {errors.simage && <p className="help" style={{ color: 'red' }}>{errors.simage}</p>}
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-1 sm:grid-cols-1 sm:mb-3">

                                        {image && (
                                            <div className="card">
                                                <header className="card-header">
                                                    <p className="card-header-title">
                                                        Image Preview
                                                    </p>
                                                </header>

                                                <div className="card-content">
                                                    <div style={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: "15px"
                                                    }}>
                                                        <div style={{
                                                            position: "relative",
                                                            width: "120px",
                                                            height: "100px"
                                                        }}>
                                                            {/* DELETE BUTTON */}
                                                            <button
                                                                type="button"
                                                                onClick={handleRemoveImage}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "-8px",
                                                                    right: "-8px",
                                                                    background: "red",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    borderRadius: "50%",
                                                                    width: "22px",
                                                                    height: "22px",
                                                                    cursor: "pointer",
                                                                    fontSize: "12px",
                                                                    zIndex: 10
                                                                }}
                                                            >
                                                                ✕
                                                            </button>

                                                            {/* IMAGE */}
                                                            <img
                                                                src={image.preview}
                                                                alt="preview"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "cover",
                                                                    borderRadius: "6px",
                                                                    border: "1px solid #ddd"
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="field">
                                        <label className="label">Description <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <textarea className="textarea" id="description" placeholder="Description" value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} ></textarea>
                                        </div>
                                        {errors.description && <p className="help" style={{ color: 'red' }}>{errors.description}</p>}
                                    </div>
                                    <div className="field spaced">
                                        <div className="control">
                                            <label className="checkbox label"><input type="checkbox" name="isActive" id="isActive" checked={formData.isActive} onChange={e => setFormData({ ...formData, isActive: e.target.checked })} />
                                                <span className="check"></span>
                                                <span className="control-label">Active</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="flex justify-center items-center">
                                        <div className="field grouped">
                                            <div className="control">
                                                <button type="submit" className="button green">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddCoupon;